import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "flag-icons-th",
  viewBox: "0 0 640 480"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#f4f5f8",
    d: "M0 0h640v480H0z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#2d2a4a",
    d: "M0 162.5h640v160H0z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#a51931",
    d: "M0 0h640v82.5H0zm0 400h640v80H0z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }